const PASSPHRASE_CHARACTERS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789_-?.;'
const GENERATED_PASSPHRASE_LENGTH = 16

export const generatePassphrase = (): string => {
  const randomValues = crypto.getRandomValues(new Uint32Array(GENERATED_PASSPHRASE_LENGTH))
  return Array.from(randomValues, value => PASSPHRASE_CHARACTERS[value % PASSPHRASE_CHARACTERS.length]).join('')
}
